import type { RouteRecordRaw } from 'vue-router';

export const featureCategoryRoutes: Array<RouteRecordRaw> = [
  {
    path: '/feature/category',
    name: 'featureCategory',
    redirect: '/feature/category/list',
    component: () => import('pages/trade/admin/featureCategory/FeatureCategory.vue'),
    meta: {
      title: 'Feature Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'featureCategoryList',
        component: () => import('pages/trade/admin/featureCategory/FeatureCategoryList.vue'),
        meta: {
          title: 'Feature Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'featureCategoryDetail',
        component: () => import('pages/trade/admin/featureCategory/FeatureCategoryDetail.vue'),
        meta: {
          title: 'FeatureCategory Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'featureCategoryNew',
        component: () => import('pages/trade/admin/featureCategory/FeatureCategoryNew.vue'),
        meta: {
          title: 'New FeatureCategory',
          requiresAuth: true,
        },
      },
    ],
  },
];
